import { useEffect, useState, useRef } from 'react';

import { isBeforeSale } from '../utils/isBeforeSale';


const Timer = (props) => {
    const [days, setDays] = useState('');
    const [hours, setHours] = useState('');
    const [minutes, setMinutes] = useState('');
    const [seconds, setSeconds] = useState('');
    const determineDate = isBeforeSale();
    let interval = useRef();
    const timer = () => {

        interval = setInterval(() => {
            const now = new Date().getTime();
            const distanceToEndDate = new Date(props.endDate).valueOf() - now;
            const distanceToStartDate = new Date(props.startDate).valueOf() - now;
            const second = 1000;
            const minute = second * 60;
            const hour = minute * 60;
            const day = hour * 24;

            if (distanceToEndDate < 0) {
                // If it's the end date of the sale then stop the interval/timer.
                clearInterval(interval.current);
            } else {
                // Otherwise continue updating the interval/timer.
                if (determineDate) {
                    setDays(Math.floor(distanceToStartDate / day));
                    setHours(Math.floor((distanceToStartDate % day) / hour));
                    setMinutes(Math.floor((distanceToStartDate % hour) / minute));
                    setSeconds(Math.floor((distanceToStartDate % minute) / second));
                } else {
                    setDays(Math.floor(distanceToEndDate / day));
                    setHours(Math.floor((distanceToEndDate % day) / hour));
                    setMinutes(Math.floor((distanceToEndDate % hour) / minute));
                    setSeconds(Math.floor((distanceToEndDate % minute) / second));
                }
            }

        }, 1000);
    }

    useEffect(() => {
        timer();
        return clearInterval(interval.current);
    });

	const formatValue = (value) => {
		return value.toString().padStart(2, '0');
	};

	return (
		<span style={{ margin: '0px' }}>
			{formatValue(days)}d, {formatValue(hours)}h, {formatValue(minutes)}m,{' '}
			{formatValue(seconds)}s.
		</span>
	);
}

export default Timer;
